import { useMutation } from "@tanstack/react-query";
import { API } from "../../utils/API/API";

export const useChatBot = () => {
  return useMutation({
    mutationFn: (data: { system: string; prompt: string }) => API.chatbot(data),
  });
};
